import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  BillingResponse,
  DailyUsageResponse,
  fetchBillingApi,
  fetchDailyUsageApi,
} from "../pages/setting/AiUsage/aiUsageApi";

export const fetchDailyUsage = createAsyncThunk<
  DailyUsageResponse,
  { year: number; month: number }
>("aiUsage/fetchDaily", async ({ year, month }, { rejectWithValue }) => {
  try {
    return await fetchDailyUsageApi(year, month);
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data || "Failed to fetch AI usage daily"
    );
  }
});

export const fetchBilling = createAsyncThunk<
  BillingResponse,
  { months?: number; before?: string } | undefined
>("aiUsage/fetchBilling", async (args, { rejectWithValue }) => {
  try {
    return await fetchBillingApi(args?.months ?? 12, args?.before);
  } catch (error: any) {
    return rejectWithValue(
      error?.response?.data || "Failed to fetch AI usage billing"
    );
  }
});

interface AiUsageState {
  daily: DailyUsageResponse | null;
  billing: BillingResponse | null;
  loadingDaily: boolean;
  loadingBilling: boolean;
  error: string | null;
}

const initialState: AiUsageState = {
  daily: null,
  billing: null,
  loadingDaily: false,
  loadingBilling: false,
  error: null,
};

const aiUsageSlice = createSlice({
  name: "aiUsage",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDailyUsage.pending, (state) => {
        state.loadingDaily = true;
        state.error = null;
      })
      .addCase(fetchDailyUsage.fulfilled, (state, action) => {
        state.loadingDaily = false;
        state.daily = action.payload;
      })
      .addCase(fetchDailyUsage.rejected, (state) => {
        state.loadingDaily = false;
        state.error = "利用状況の取得に失敗しました";
      })
      .addCase(fetchBilling.pending, (state) => {
        state.loadingBilling = true;
      })
      .addCase(fetchBilling.fulfilled, (state, action) => {
        state.loadingBilling = false;
        state.billing = action.payload;
      })
      .addCase(fetchBilling.rejected, (state) => {
        state.loadingBilling = false;
        state.error = "請求情報の取得に失敗しました";
      });
  },
});

export default aiUsageSlice.reducer;
